import { designTokens } from './example-design-tokens';
export function injectDesignTokensOption(optionsOverride) {
  var result = optionsOverride || {};
  result.tokens = result.tokens || designTokens;
  return result;
}